import React, { FC } from 'react'
import { Formik, Form, FormikHelpers } from 'formik'
import { FormValues } from '../../models/form'
import createValidationSchema from '../../utils/createValidationSchema'

type FormProps = {
  onSubmit: (values: FormValues, actions: FormikHelpers<any>) => void
  initialValues: FormValues | any
  validation?: string
  innerRef?: any
  enableReinitialize?: boolean
}

const GeneralForm: FC<FormProps> = ({ children, validation, ...props }) => {
  const validationSchema = validation && createValidationSchema(props.initialValues, validation)

  return (
    <Formik {...{ ...props, validationSchema }}>
      <Form className='general-form'>{children}</Form>
    </Formik>
  )
}

export default GeneralForm
